module.exports = __webpack_public_path__ + "static/media/logo-pin.26a65423.svg";